import React from 'react';
import RootErrorPage from './RootErrorPage';
import type { FallbackProps } from 'react-error-boundary';
import Button from '@/components/Button/Button';
import tokens from '@/core/tokens.json';

function ErrorBoundaryRoot({ error, resetErrorBoundary }: FallbackProps) {
  const CTA = () => (
    <Button variant="contained" onClick={resetErrorBoundary}>
      {tokens.TRY}
    </Button>
  );
  return <RootErrorPage title={tokens.WRONG} description={error.message} cta={<CTA />} />;
}

export default ErrorBoundaryRoot;
